// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"418654e8","173":"f0c41a0f","359":"f0c41a0f","401":"cecdc7e4","756":"418654e8","837":"f0c41a0f","915":"f0c41a0f","995":"418654e8"}[chunkId] + ".chunk.css";
};